import { render, staticRenderFns } from "./ActivityList.vue?vue&type=template&id=72e8dab4&scoped=true&"
import script from "./ActivityList.vue?vue&type=script&lang=ts&"
export * from "./ActivityList.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityList.vue?vue&type=style&index=0&id=72e8dab4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e8dab4",
  null
  
)

export default component.exports